import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetCustomerLocationGroupsQueryVariables = Types.Exact<{
  groupBy: Types.CustomerLocationGroupField;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCustomerLocationGroupsQuery = { __typename?: 'Query', customerLocationGroups: Array<{ __typename?: 'CustomerLocationGroupBucket', key: string, label: string, count: number }> };


export const GetCustomerLocationGroupsDocument = new TypedDocumentString(`
    query GetCustomerLocationGroups($groupBy: CustomerLocationGroupField!, $search: String) {
  customerLocationGroups(groupBy: $groupBy, search: $search) {
    key
    label
    count
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetCustomerLocationGroups: build.query<GetCustomerLocationGroupsQuery, GetCustomerLocationGroupsQueryVariables>({
      query: (variables) => ({ document: GetCustomerLocationGroupsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetCustomerLocationGroupsQuery, useLazyGetCustomerLocationGroupsQuery } = injectedRtkApi;
